var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headnavigation',{attrs:{"flow":_vm.flow}}),_c('hr'),_c('staff')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }